/*
 * @Author: llzq
 * @Date: 2020-12-12 14:30:21
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 14:02:24
 * @Description:  头部注释
 */
import React, { Component } from "react";
import {Alert} from "antd";
import { HotTable } from "@handsontable/react";
import { doImport, getImportResult } from "../upload.api";
interface iProps {
  importToken: string;
  url: string;

  onFinish: () => void;
}
export default class UploadResult extends Component<iProps> {
  state = {
    importState: "",
    currentLine: 0,
    errorMsgs: [],
    failedNumber: 0,
    successNumber: 0,
    totalNumber: 0,
  };
  componentDidMount() {
    window["UploadResult"] = this;
    this.pollDataMessage();
  }
  getImportResult = async () => {
    let { data } = await getImportResult(this.props.importToken,this.props.url);
    this.setState({
      ...data,
    });
  };
  pollDataMessage = () => {
    window.setTimeout(async() => {
      if (this.state.importState !== "FINISHED") {
        await this.getImportResult();
        this.pollDataMessage();
      } else {
        this.props.onFinish();
      }
    }, 1000);
  };
  render() {
    let {
      importState = "",
      currentLine = 0,
      errorMsgs = [],
      failedNumber = 0,
      successNumber = 0,
      totalNumber = 0,
    } = this.state;
    let settings = {
      colHeaders: ["错误行数", "错误原因"],
      stretchH: "all" as "all" | "none" | "last",
      rowHeaders: false,
      fixedColumnsLeft: 1,
      data: errorMsgs,
      width: "100%",
      height: "258",
      licenseKey: "non-commercial-and-evaluation",
      manualColumnResize: true,
      readOnly: true,
    };
    return (
      <div>
        <div className="upload-result-header">
          {importState === "FINISHED" && (
            <Alert
              message="数据导入完毕！"
              description={`你所上传的文件数据已经导入完毕，成功${successNumber}条，失败${failedNumber}条，总计${totalNumber}条`}
              type="success"
              showIcon
            />
          )}
          {importState !== "FINISHED" && (
            <Alert
              message="数据正在导入！"
              description={`您所上传的文件数据导入到${currentLine}行，成功${successNumber}条，失败${failedNumber}条，总计${totalNumber}条`}
              type="info"
              showIcon
            />
          )}
        </div>
        {importState === "FINISHED" && errorMsgs.length > 0 && (
          <>
          <div className="upload-result-table-header">失败数据</div>
          <HotTable settings={settings}></HotTable>
          </>
        )}
      </div>
    );
  }
}
